import { jsx as _jsx } from "react/jsx-runtime";
import './controlGroup.css';
export const ControlGroup = ({ children }) => {
    return (_jsx("div", { className: "control-group", children: children }));
};
